import { fishboneDirection_Horizontal, fishboneDirection_Vertical } from './types.js';
export const flipFishbone = (original) => {
    const direction = original.direction === fishboneDirection_Horizontal ? fishboneDirection_Vertical : fishboneDirection_Horizontal;
    const ribs = [];
    //Translate the ribs to new direction
    //Logic behind this: no matter the direction of the fishbone, using the amount of variable ids in each
    //rib to create a new rib will cause the fishbone to be flipped
    original.ribs.forEach(rib => {
        rib.ribItems.forEach((ribItem, index) => {
            if (!ribs[index])
                ribs[index] = { ribItems: [], slantDividers: false };
            ribs[index].ribItems.push(ribItem);
        });
    });
    const result = {
        key: original.key,
        label: original.label,
        head: original.head,
        tail: original.tail,
        direction: direction,
        ribs: ribs,
    };
    //fishbone optional keys cleanup
    if (!result.head)
        delete result.head;
    if (!result.tail)
        delete result.tail;
    return result;
};
export const convertFishBone_100_101 = (struct) => {
    if (struct.head) {
        struct.head.variableIds = [struct.head.variableId];
        // @ts-ignore
        delete struct.head.variableId;
    }
    if (struct.tail) {
        struct.tail.variableIds = [struct.tail.variableId];
        // @ts-ignore
        delete struct.tail.variableId;
    }
    struct.ribs.forEach(rib => {
        rib.ribItems.forEach(ribItem => {
            ribItem.variableIds = [ribItem.variableId];
            // @ts-ignore
            delete ribItem.variableId;
        });
    });
};
//# sourceMappingURL=consts.js.map